import { render, staticRenderFns } from "./core-top-users-wage-chart.vue?vue&type=template&id=4f979592&scoped=true"
import script from "./core-top-users-wage-chart.vue?vue&type=script&lang=js"
export * from "./core-top-users-wage-chart.vue?vue&type=script&lang=js"
import style0 from "./core-top-users-wage-chart.vue?vue&type=style&index=0&id=4f979592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f979592",
  null
  
)

export default component.exports